import { useEffect, useState } from "react";
import moment from "moment";

interface PeriodoTagProps {
  id: string;
  operacao: any;
  planejamentos: any[];
}

function PeriodoTag({ id, operacao, planejamentos }: PeriodoTagProps) {

  const [periodo, setPeriodo] = useState<string>();

  function getPeriodo() {
    if (id && operacao.planoOperacionalReferencia === "Data pré definida") {
      const operacoes = planejamentos.map(p => p.planoOperacionalOperacoes).flat();
      const vinculo = operacoes.find(o => o.planoOperacionalOperacaoId === id);
      const periodoInicio = moment(vinculo.talhoes[0].periodoDataInicio).format("DD/MM/YYYY");
      const periodoFim = moment(vinculo.talhoes[0].periodoDataFim).format("DD/MM/YYYY");
      setPeriodo(`${periodoInicio} - ${periodoFim}`);
      return;
    }
    setPeriodo(undefined);
  }

  useEffect(() => {
    getPeriodo();
  }, [id, operacao]);

  return (
    <div>
      <p>{periodo ?? "-"}</p>
    </div>
  );
}

export default PeriodoTag;
